var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Button',{staticStyle:{"margin":"5px"},attrs:{"type":"info"},on:{"click":_vm.showAPIreadme}},[_vm._v("API地址代理对照表")]),(_vm.tips)?_c('div',[_vm._v(" API地址代理转换：对于平台内的API地址，将域名段转换为代理编码，可以满足各种环境的应用（测试、生产）。 ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }